// Constants (copied from your original component)
const BORDER_RADIUS_FRAME = 4;
const BORDER_RADIUS_PILLOW = 8;
const BORDER_RADIUS_SEAT = 12;
const DEFAULT_DIMENSIONS = {
  'alex-sofa': {
    width: 66,
    depth: 38,
  },
  'merced-sofa': {
    width: 66,
    depth: 38
  },
  'daphne-sofa': {
    width: 66,
    depth: 40
  }
}
const POPULAR = {
  'alex-sofa': {
    width: 86,
    depth: 38,
  },
  'merced-sofa':  {
    width: 86,
    depth: 38,
  },
  'daphne-sofa': {
    width: 90,
    depth: 42
  },
  chaise: {
    width: 108,
    depth: 42,
    chaise: {
      width: 30,
      length: 70,
    },
  },
  sofa: {
    width: 90,
    depth: 42,
  },
};
const FRAME_GAP = 5;
const HEIGHT_OFFSET = 10;
const BORDER_WIDTH = 3;
const FRAME_PADDING = 40;
const DEFAULT_DEPTH = {
  40: { seat: 23 },
  42: { seat: 25 },
  44: { seat: 27 },
  46: { seat: 29 },
  48: { seat: 31 },
};
const DEPTHS = {
  'alex-sofa': {
    36: { seat: 19 },
    38: { seat: 21 },
    40: { seat: 23 },
    42: { seat: 25 },
    44: { seat: 27 },
    46: { seat: 29 },
  },
  'merced-sofa': {
    36: { seat: 18 },
    38: { seat: 20 },
    40: { seat: 22 },
    42: { seat: 24 },
    44: { seat: 26 },
    46: { seat: 28 },
  },
  'daphne-sofa': {
    40: { seat: 23 },
    42: { seat: 25 },
    44: { seat: 27 },
    46: { seat: 29 },
    48: { seat: 31 }
  }
};
const CHAISE_LENGTHS_DEFAULT = [62, 66, 70, 74, 78, 82, 86, 90, 94, 98];
const CHAISE_WIDTHS = [28, 30, 32, 34, 36, 38];
const CHAISE_LENGTHS = { daphne: CHAISE_LENGTHS_DEFAULT };
const DIRECTIONS = { chaise: ["left", "right"] };

// Width data from your original component
const WIDTHS = {
  chaise: {
    72: {
      arm: 6,
      inside: 56,
      body: 28,
      chaise: { width: [28], length: CHAISE_LENGTHS_DEFAULT },
      seat: { 1: 28 },
    },
    76: {
      arm: 6,
      inside: 60,
      body: 32,
      chaise: { width: [28], length: CHAISE_LENGTHS_DEFAULT },
      seat: { 1: 32 },
    },
    80: {
      arm: 6,
      inside: 64,
      body: 36,
      chaise: { width: [28], length: CHAISE_LENGTHS_DEFAULT },
      seat: { 1: 36 },
    },
    84: {
      arm: 6,
      inside: 68,
      body: 40,
      chaise: { width: [28], length: CHAISE_LENGTHS_DEFAULT },
      seat: { 1: 40 },
    },
    88: {
      arm: 6,
      inside: 72,
      body: 44,
      chaise: { width: [28], length: CHAISE_LENGTHS_DEFAULT },
      seat: { 1: 44 },
    },
    92: {
      arm: 6,
      inside: 76,
      body: 48,
      chaise: { width: [28], length: CHAISE_LENGTHS_DEFAULT },
      seat: { 1: 48 },
    },
    96: {
      arm: 6,
      inside: 80,
      body: 50,
      chaise: { width: [30], length: CHAISE_LENGTHS_DEFAULT },
      seat: { 1: 50 },
    },
    100: {
      arm: 6,
      inside: 84,
      body: 56,
      chaise: { width: [28], length: CHAISE_LENGTHS_DEFAULT },
      seat: { 2: 28, 1: 56 },
    },
    104: {
      arm: 6,
      inside: 88,
      body: 58,
      chaise: { width: [30], length: CHAISE_LENGTHS_DEFAULT },
      seat: { 2: 29, 1: 58 },
    },
    108: {
      arm: 6,
      inside: 92,
      body: 62,
      chaise: { width: [30], length: CHAISE_LENGTHS_DEFAULT },
      seat: { 2: 31, 1: 62 },
    },
    112: {
      arm: 6,
      inside: 96,
      body: 64,
      chaise: { width: [32], length: CHAISE_LENGTHS_DEFAULT },
      seat: { 2: 32, 1: 64 },
    },
    116: {
      arm: 6,
      inside: 100,
      body: 68,
      chaise: { width: [32], length: CHAISE_LENGTHS_DEFAULT },
      seat: { 2: 34, 1: 68 },
    },
    120: {
      arm: 6,
      inside: 104,
      body: 72,
      chaise: { width: [32], length: CHAISE_LENGTHS_DEFAULT },
      seat: { 2: 36 },
    },
    124: {
      arm: 6,
      inside: 108,
      body: 76,
      chaise: { width: [32], length: CHAISE_LENGTHS_DEFAULT },
      seat: { 2: 38 },
    },
    128: {
      arm: 6,
      inside: 112,
      body: 83,
      chaise: { width: [29], length: CHAISE_LENGTHS_DEFAULT },
      seat: { 3: 28, 2: 41.5 },
    },
    132: {
      arm: 6,
      inside: 116,
      body: 85,
      chaise: { width: [31], length: CHAISE_LENGTHS_DEFAULT },
      seat: { 3: 28, 2: 42.5 },
    },
    136: {
      arm: 6,
      inside: 120,
      body: 90,
      chaise: { width: [30], length: CHAISE_LENGTHS_DEFAULT },
      seat: { 3: 30, 2: 45 },
    },
    140: {
      arm: 6,
      inside: 124,
      body: 93,
      chaise: { width: [31], length: CHAISE_LENGTHS_DEFAULT },
      seat: { 3: 31, 2: 46.5 },
    },
    144: {
      arm: 6,
      inside: 128,
      body: 96,
      chaise: { width: [32], length: CHAISE_LENGTHS_DEFAULT },
      seat: { 3: 32, 2: 48 },
    },
    148: {
      arm: 6,
      inside: 132,
      body: 99,
      chaise: { width: [33], length: CHAISE_LENGTHS_DEFAULT },
      seat: { 3: 33, 2: 49.5 },
    },
  },
  sofa: {
    66: { arm: 6, seat: { 1: 54, 2: 27 } },
    70: { arm: 6, seat: { 1: 58, 2: 29 } },
    74: { arm: 6, seat: { 2: 29} },
    78: { arm: 6, seat: { 2: 33} },
    82: { arm: 6, seat: { 2: 35 } },
    86: { arm: 6, seat: { 2: 37, 3: 24.6 } },
    90: { arm: 6, seat: { 2: 39, 3: 26 } },
    94: { arm: 6, seat: { 3: 27.3, 2: 41 } },
    98: { arm: 6, seat: { 3: 28.7, 2: 43 } },
    102: { arm: 6, seat: { 3: 30, 2: 45 } },
    106: { arm: 6, seat: { 3: 31.3, 2: 45 } },
  },
   'alex-sofa': {
    66: { arm: 6, seat: { 1: 54, 2: 27 } },
    70: { arm: 6, seat: { 1: 58, 2: 29 } },
    74: { arm: 6, seat: { 2: 29} },
    78: { arm: 6, seat: { 2: 33} },
    82: { arm: 6, seat: { 2: 35 } },
    86: { arm: 6, seat: { 2: 37, 3: 24.6 } },
    90: { arm: 6, seat: { 2: 39, 3: 26 } },
    94: { arm: 6, seat: { 3: 27.3, 2: 41 } },
    98: { arm: 6, seat: { 3: 28.7, 2: 43 } },
    102: { arm: 6, seat: { 3: 30, 2: 45 } },
    106: { arm: 6, seat: { 3: 31.3, 2: 45 } },
  },
  'merced-sofa': {
    66: { arm: 6, seat: { 1: 54, 2: 27 } },
    70: { arm: 6, seat: { 1: 58, 2: 29 } },
    74: { arm: 6, seat: { 2: 29} },
    78: { arm: 6, seat: { 2: 33} },
    82: { arm: 6, seat: { 2: 35 } },
    86: { arm: 6, seat: { 2: 37, 3: 24.6 } },
    90: { arm: 6, seat: { 2: 39, 3: 26 } },
    94: { arm: 6, seat: { 3: 27.3, 2: 41 } },
    98: { arm: 6, seat: { 3: 28.7, 2: 43 } },
    102: { arm: 6, seat: { 3: 30, 2: 45 } },
    106: { arm: 6, seat: { 3: 31.3, 2: 45 } },
  },
  'daphne-sofa': {
    66: { arm: 8, seat: { 1: 50 } },
    70: { arm: 8, seat: { 1: 54, 2: 27 } },
    74: { arm: 8, seat: { 1: 58, 2: 29} },
    78: { arm: 8, seat: { 1: 62, 2: 31} },
    82: { arm: 8, seat: { 1: 66, 2: 33 } },
    86: { arm: 8, seat: { 1: 70, 2: 35 } },
    90: { arm: 8, seat: { 1: 74, 2: 37 } },
    94: { arm: 8, seat: { 2: 39, 3: 26 } },
    98: { arm: 8, seat: { 2: 41, 3: 27.3 } },
    102: { arm: 8, seat: { 2: 43, 3: 28.7 } },
    106: { arm: 8, seat: { 2: 45, 3: 30 } },
  },
};

function pluralize(string, n, withCommas = false, wordOnly = false) {
  const whitelist = [
    'run',
  ];
  let number = n;
  const hasNumber = number !== undefined && number !== null;
  if (!hasNumber) {
    number = 2;
  }
  let word;
  if (number === 1) {
    word = string;
  } else {
    const length = string.length;
    const lastLetter = string[length - 1];
    const iswhitelisted = whitelist.includes(string);
    if (!iswhitelisted && lastLetter === 'y' && string !== 'day') {
      word = string.slice(0, length - 1) + 'ies';
    } else if (!iswhitelisted && lastLetter === 's') {
      word = string + 'es';
    } else {
      word = string + 's';
    }
  }

  if (hasNumber && !wordOnly) {
    const numberText = withCommas ? numberWithCommas(number) : number;
    return numberText + ' ' + word;
  }

  return word;
}

// Helper function for formatting numbers with commas
function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

// Helper functions
function isNumeric(str) {
  if (typeof str === "undefined" || str === null) {
    return false;
  }
  return !isNaN(str);
}

function formatNumber(num) {
  // Round to 2 decimal places
  const rounded = Math.round(num * 100) / 100;

  // Check if it's a whole number
  if (rounded % 1 === 0) {
    return Math.floor(rounded);
  } else {
    return rounded;
  }
}

function range(numberOfItems, endIndex) {
  const num = endIndex ?? false ? endIndex - numberOfItems : numberOfItems;
  if (isNumeric(num) && num >= 1) {
    return Array(num)
      .fill(0)
      .map((_, i) => i + (endIndex ?? false ? numberOfItems : 0));
  }
  return [];
}

// Text Component
class Text extends React.Component {
  render() {
    const { children, style, small } = this.props;

    const defaultStyle = {
      color: "#202020",
      fontFamily: "Satoshi, sans-serif",
      fontSize: "18px",
      fontWeight: 500,
      lineHeight: "32px",
      margin: 0,
      ...(small
        ? {
          fontSize: 14,
          fontWeight: 400,
          lineHeight: "26px",
        }
        : {}),
      ...style,
    };

    return React.createElement("p", { style: defaultStyle }, children);
  }
}

// TickedSlider Component
class TickedSlider extends React.Component {
  constructor(props) {
    super(props);
    const { widths, value, maxWidth } = props;
    const widthValues = Object.keys(widths)
      .sort((a, b) => a - b)
      .map(Number);
    const min = widthValues[0];

    this.state = {
      value: value ?? min,
      fillPercentage: 0,
      isDragging: false,
    };

    this.sliderRef = React.createRef();
    this.handleSliderClick = this.handleSliderClick.bind(this);
    this.handleMouseDown = this.handleMouseDown.bind(this);
    this.handleMouseMove = this.handleMouseMove.bind(this);
    this.handleMouseUp = this.handleMouseUp.bind(this);
    this.calculateFillPercentage = this.calculateFillPercentage.bind(this);

    this.handleTouchStart = this.handleTouchStart.bind(this);
    this.handleTouchMove = this.handleTouchMove.bind(this);
    this.handleTouchEnd = this.handleTouchEnd.bind(this);
  }

  handleTouchStart(e) {
    e.stopPropagation();
    this.setState({ isDragging: true });
    document.addEventListener("touchmove", this.handleTouchMove, { passive: false });
    document.addEventListener("touchend", this.handleTouchEnd);
    document.body.style.touchAction = "none";
  }

  handleTouchMove(e) {
    if (this.state.isDragging && this.sliderRef.current) {
      e.preventDefault(); // Prevent scrolling while dragging
      const sliderRect = this.sliderRef.current.getBoundingClientRect();
      const touch = e.touches[0];
      const posX = Math.max(
        0,
        Math.min(touch.clientX - sliderRect.left, sliderRect.width)
      );
      this.updateValueFromPosition(posX, sliderRect.width);
    }
  }

  handleTouchEnd() {
    this.setState({ isDragging: false });
    document.removeEventListener("touchmove", this.handleTouchMove);
    document.removeEventListener("touchend", this.handleTouchEnd);
    document.body.style.touchAction = "";
  }

  componentDidMount() {
    this.calculateFillPercentage();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.value !== this.props.value &&
      this.props.value !== undefined
    ) {
      this.setState({ value: this.props.value }, this.calculateFillPercentage);
    }
  }

  calculateFillPercentage() {
    const { widths } = this.props;
    const { value } = this.state;
    const widthValues = Object.keys(widths)
      .sort((a, b) => a - b)
      .map(Number);
    const min = widthValues[0];
    const max = widthValues[widthValues.length - 1];

    const percentage = ((value - min) / (max - min)) * 100;
    this.setState({ fillPercentage: percentage });
  }

  findClosestWidth(targetValue) {
    const { widths } = this.props;
    const widthValues = Object.keys(widths)
      .sort((a, b) => a - b)
      .map(Number);

    return widthValues.reduce((prev, curr) =>
      Math.abs(curr - targetValue) < Math.abs(prev - targetValue) ? curr : prev
    );
  }

  handleSliderClick(e) {
    if (!this.state.isDragging) {
      const sliderRect = e.currentTarget.getBoundingClientRect();
      const clickPosition = e.clientX - sliderRect.left;
      this.updateValueFromPosition(clickPosition, sliderRect.width);
    }
  }

  handleMouseDown(e) {
    e.stopPropagation();
    this.setState({ isDragging: true });
    document.addEventListener("mousemove", this.handleMouseMove);
    document.addEventListener("mouseup", this.handleMouseUp);
    document.body.style.cursor = "grabbing";
  }

  handleMouseMove(e) {
    if (this.state.isDragging && this.sliderRef.current) {
      const sliderRect = this.sliderRef.current.getBoundingClientRect();
      const posX = Math.max(
        0,
        Math.min(e.clientX - sliderRect.left, sliderRect.width)
      );
      this.updateValueFromPosition(posX, sliderRect.width);
    }
  }

  handleMouseUp() {
    this.setState({ isDragging: false });
    document.removeEventListener("mousemove", this.handleMouseMove);
    document.removeEventListener("mouseup", this.handleMouseUp);
    document.body.style.cursor = "";
  }

  updateValueFromPosition(position, width) {
    const { widths, onChange } = this.props;
    const widthValues = Object.keys(widths)
      .sort((a, b) => a - b)
      .map(Number);
    const min = widthValues[0];
    const max = widthValues[widthValues.length - 1];

    const percentage = (position / width) * 100;
    const rawValue = (percentage * (max - min)) / 100 + min;
    const newValue = this.findClosestWidth(rawValue);

    this.setState({ value: newValue }, this.calculateFillPercentage);

    if (onChange) {
      onChange(newValue);
    }
  }

  render() {
    const { label, widths, popularValues } = this.props;
    const { value, fillPercentage } = this.state;
    const widthValues = Object.keys(widths)
      .sort((a, b) => a - b)
      .map(Number);
    const min = widthValues[0];
    const max = widthValues[widthValues.length - 1];

    // Process popular values markers if provided
    const popularMarkers = popularValues && Array.isArray(popularValues)
      ? popularValues.filter(pv => {
        // Only include popular values that are within the slider range
        return pv.value >= min && pv.value <= max;
      }).map(pv => {
        // Calculate position percentage for each popular value
        const percentage = ((pv.value - min) / (max - min)) * 100;
        return {
          ...pv,
          position: percentage
        };
      })
      : [];

    return React.createElement(
      "div",
      {
        style: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          position: "relative",
          marginTop: "10px",
        },
      },
      [
        React.createElement(
          Text,
          {
            key: "label",
            style: { fontWeight: 500, marginBottom: "5px" },
            small: true,
          },
          label
        ),

        React.createElement(
          "div",
          {
            key: "slider-container",
            style: {
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexDirection: "row",
              width: this.props.maxWidth,
              gap: 20,
            },
          },
          [
            React.createElement(
              "div",
              {
                key: "min-label",
                style: {
                  position: "relative",
                  width: 60,
                  display: "flex",
                  justifyContent: "flex-end",
                  alignContent: "center",
                },
              },
              React.createElement(Text, { small: true }, min, "\u201D")
            ),

            React.createElement(
              "div",
              {
                key: "slider",
                className: "ticked__slider",
                "data-pdp-size-select": "",
                style: {
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  position: "relative",
                },
              },
              [
                React.createElement(
                  "div",
                  {
                    className: "slider-track",
                    ref: this.sliderRef,
                    onClick: this.handleSliderClick,
                    onTouchStart: (e) => {
                      if (e.target === e.currentTarget) {
                        const sliderRect = e.currentTarget.getBoundingClientRect();
                        const touch = e.touches[0];
                        const touchPosition = touch.clientX - sliderRect.left;
                        this.updateValueFromPosition(touchPosition, sliderRect.width);
                      }
                    },
                    style: {
                      width: "100%",
                      height: "4px",
                      backgroundColor: "#e0e0e0",
                      borderRadius: "3px",
                      position: "relative",
                      cursor: "pointer",
                      marginBottom: "15px", // Space for the popular value markers
                    },
                  },
                  [
                    // Track fill
                    React.createElement("div", {
                      key: "fill",
                      className: "slider-fill",
                      style: {
                        position: "absolute",
                        height: "100%",
                        width: `${fillPercentage}%`,
                        backgroundColor: "#124a6a",
                        borderRadius: "2px",
                      },
                    }),

                    // Popular value markers
                    ...popularMarkers.map((marker, index) =>
                      React.createElement("div", {
                        key: `popular-marker-${index}`,
                        style: {
                          position: "absolute",
                          top: "50%", // Center vertically with the track
                          left: `${marker.position}%`,
                          transform: "translateX(-50%)", // Center horizontally
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          cursor: "pointer",
                        },
                        onClick: () => {
                          this.setState({ value: marker.value }, () => {
                            this.calculateFillPercentage();
                            if (this.props.onChange) {
                              this.props.onChange(marker.value);
                            }
                          });
                        }
                      }, [
                        // Tick mark - now extends both up and down from center
                        React.createElement("div", {
                          style: {
                            width: "1px",
                            height: "16px", // Increased height
                            backgroundColor: "#124a6a",
                            position: "absolute",
                            top: "50%",
                            transform: "translateY(-50%)" // Center at the slider track
                          }
                        }),
                        // Label - positioned below the tick
                        React.createElement(Text, {
                          small: true,
                          style: {
                            fontSize: "12px",
                            whiteSpace: "nowrap",
                            color: '#666666',
                            // color: marker.value === value ? "#124a6a" : "#666666",
                            // fontWeight: marker.value === value ? "bold" : "normal",
                            position: "absolute",
                            top: "5px" // Positioned below the tick
                          }
                        }, marker.label || `${marker.value}″`)
                      ])
                    ),

                    // Thumb
                    React.createElement("div", {
                      key: "thumb",
                      className: "slider-thumb",
                      onMouseDown: this.handleMouseDown,
                      onTouchStart: this.handleTouchStart,
                      style: {
                        position: "absolute",
                        width: "16px",
                        height: "16px",
                        borderRadius: "50%",
                        backgroundColor: "white",
                        border: "3px solid #124a6a",
                        top: "50%",
                        left: `${fillPercentage}%`,
                        transform: "translate(-50%, -50%)",
                        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
                        zIndex: 3,
                        cursor: "grab",
                        userSelect: "none",
                      },
                    }),
                  ]
                ),
              ]
            ),

            React.createElement(
              "div",
              {
                key: "max-label",
                style: {
                  position: "relative",
                  width: 60,
                  display: "flex",
                  justifyContent: "flex-start",
                  alignContent: "center",
                },
              },
              React.createElement(Text, { small: true }, max, "\u201D")
            ),
          ]
        ),
      ]
    );
  }
}

class SofaSlider extends React.Component {
  constructor(props) {
    super(props);

    // Access all the dataset props passed to the component
    const {
      builderConfiguration,
      builderStyle,
      cornerSettings,
      fabricCollection,
      firmnessProduct,
      fabricColor,
      fabricTypes,
      fabricPatterns,
      fabricPopularCollections,
      sizeImage,
      sizeModalContent,
      sizeDescription,
      sizeModalPage,
      legOptions,
      legOptionsPopup,
      legModalPage,
      sizeOptions,
      productId,
      productHandle,
      productMetafieldsSize,
      productMetafieldsBuilderInfo,
      blockSettings,
    } = props;

    // Log to see all available props
    console.log("SofaSlider props:", props);

    const configuration = props.configuration || "chaise";
    const withChaise = configuration === "chaise";

    this.state = {
      configuration,
      withChaise,
      direction: "right",
      depth: DEFAULT_DIMENSIONS[productHandle].depth,
      width: DEFAULT_DIMENSIONS[productHandle].width,
      seatsState: null,
      widthChaise: POPULAR[productHandle]?.chaise?.width || 0,
      lengthChaise: POPULAR[productHandle]?.chaise?.length || 0,
      // You can also set initial state from the props
      builderStyle,
      cornerSettings,
      fabricCollection,
      firmnessProduct,
      fabricColor,
      fabricTypes,
      fabricPatterns,
      fabricPopularCollections,
      sizeImage,
      sizeModalContent,
      sizeDescription,
      sizeModalPage,
      legOptions,
      legOptionsPopup,
      legModalPage,
      sizeOptions,
      productId,
      productHandle,
      productMetafieldsSize,
      productMetafieldsBuilderInfo,
      blockSettings,
    };

    // Bind methods
    this.setDirection = this.setDirection.bind(this);
    this.setDepth = this.setDepth.bind(this);
    this.setWidth = this.setWidth.bind(this);
    this.setSeatsState = this.setSeatsState.bind(this);
    this.setWidthChaise = this.setWidthChaise.bind(this);
    this.setLengthChaise = this.setLengthChaise.bind(this);
    this.calculateRatio = this.calculateRatio.bind(this);
    this.getSeats = this.getSeats.bind(this);
    this.renderSeats = this.renderSeats.bind(this);
    this.renderChaise = this.renderChaise.bind(this);
    this.renderFrame = this.renderFrame.bind(this);
  }

  // Modify existing setters in SofaSlider class to ensure dimensions get updated
  setWidth(width) {
    this.setState({ width }, () => {
      this.updateFormFields();
      this.updateDimensionsDisplay();
    });
  }

  setDepth(depth) {
    this.setState({ depth }, () => {
      this.updateFormFields();
      this.updateDimensionsDisplay();
    });
  }

  setWidthChaise(widthChaise) {
    this.setState({ widthChaise }, () => {
      this.updateFormFields();
    });
  }

  setLengthChaise(lengthChaise) {
    this.setState({ lengthChaise }, () => {
      this.updateFormFields();
    });
  }

  setDirection(direction) {
    this.setState({ direction }, () => {
      this.updateFormFields();
    });
  }

  setSeatsState(seatsState) {
    this.setState({ seatsState }, () => {
      this.updateFormFields();
    });
  }

  updateFormFields() {
    const {
      configuration,
      width,
      depth,
      direction,
      widthChaise,
      lengthChaise,
    } = this.state;
    const seats = this.getSeats();

    try {
      // 1. Update the corner/chaise direction radio buttons
      if (configuration === "chaise") {
        const cornerRadios = document.querySelectorAll('input[name="Corner"]');
        const targetDirection =
          direction === "right" ? "Chaise On Right" : "Chaise On Left";

        cornerRadios.forEach((radio) => {
          if (radio.value === targetDirection) {
            radio.checked = true;
            // Trigger change event
            radio.dispatchEvent(new Event("change", { bubbles: true }));
          }
        });
      }

      // 2. Update size selects for width and depth
      const sizeSelects = document.querySelectorAll(".enavi-selector_addon");
      sizeSelects.forEach((select) => {
        const type =
          select.getAttribute("data-addon-type") ||
          select.closest("[data-addon-type]")?.getAttribute("data-addon-type");

        if (type && select.options && select.options.length) {
          // For width select
          if (
            type.toLowerCase().includes("width") ||
            type.toLowerCase().includes("size")
          ) {
            // Find closest width option
            this.findAndSelectOption(select, width, "width");
          }

          // For depth select
          if (type.toLowerCase().includes("depth")) {
            this.findAndSelectOption(select, depth, "depth");
          }

          // For chaise length select
          if (
            configuration === "chaise" &&
            (type.toLowerCase().includes("chaise") ||
              type.toLowerCase().includes("length"))
          ) {
            this.findAndSelectOption(select, lengthChaise, "length");
          }
        }
      });

      // 3. Update hidden input fields for form submission
      this.updateOrCreateHiddenInput("width", width);
      this.updateOrCreateHiddenInput("depth", depth);
      this.updateOrCreateHiddenInput("seats", seats);

      if (configuration === "chaise") {
        this.updateOrCreateHiddenInput("direction", direction);
        this.updateOrCreateHiddenInput("chaise_width", widthChaise);
        this.updateOrCreateHiddenInput("chaise_length", lengthChaise);
      }

      // 4. Update visual indicators in the UI
      const sizeBox = document.querySelector(
        '.product-selector-box[data-selector-type="Size"]'
      );
      if (sizeBox) {
        const panelSelection = sizeBox.querySelector(".panel-selection");
        if (panelSelection) {
          let selectionText = `${width}" Width × ${depth}" Depth`;
          if (configuration === "chaise") {
            selectionText += ` · Chaise: ${widthChaise}" × ${lengthChaise}"`;
          }
          panelSelection.textContent = selectionText;
        }
      }

      // 5. Update cushion selection based on seats
      const cushionContainer = document.querySelector(
        "[data-cushion-container]"
      );
      if (cushionContainer) {
        const cushionOptions =
          cushionContainer.querySelectorAll(".cushion_option");

        cushionOptions.forEach((option) => {
          // Remove active class from all options
          option.classList.remove("active");

          // Match cushion options based on seat count
          const label = option.getAttribute("data-product-label");
          if (label) {
            const labelLower = label.toLowerCase();
            if (
              seats === 1 &&
              labelLower.includes("bench") &&
              labelLower.includes("1 back")
            ) {
              option.classList.add("active");
            } else if (seats === 2 && labelLower.includes("2 cushion")) {
              option.classList.add("active");
            } else if (seats === 3 && labelLower.includes("3 cushion")) {
              option.classList.add("active");
            }
          }
        });
      }

      // 6. Custom event for other modules to react to our changes
      const customEvent = new CustomEvent("sofa:configuration:changed", {
        detail: {
          width,
          depth,
          direction,
          widthChaise: configuration === "chaise" ? widthChaise : null,
          lengthChaise: configuration === "chaise" ? lengthChaise : null,
          seats,
          configuration,
        },
        bubbles: true,
      });
      document.dispatchEvent(customEvent);

      console.log("Updated form fields with:", {
        width,
        depth,
        direction,
        widthChaise,
        lengthChaise,
        seats,
        configuration,
      });
    } catch (error) {
      console.error("Error updating form fields:", error);
    }
  }

  // Helper method to find and select closest option
  findAndSelectOption(select, targetValue, type) {
    if (!select || !select.options || !select.options.length) return;

    let bestOption = null;
    let bestDiff = Infinity;

    // Try to find exact match first
    for (let i = 0; i < select.options.length; i++) {
      const option = select.options[i];
      const optionText = option.text.trim();

      // Direct match
      if (optionText.includes(`${targetValue}"`)) {
        bestOption = option;
        break;
      }

      // Extract number from option text for comparison
      const numberMatch = optionText.match(/(\d+)/);
      if (numberMatch) {
        const optionValue = parseInt(numberMatch[0], 10);
        const diff = Math.abs(optionValue - targetValue);

        if (diff < bestDiff) {
          bestDiff = diff;
          bestOption = option;
        }
      }
    }

    if (bestOption) {
      select.value = bestOption.value;
      // Trigger change events
      select.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  // Helper to update or create hidden inputs
  updateOrCreateHiddenInput(name, value) {
    const container = document.getElementById("sofa-size-slider-container");
    if (!container) return;

    let input = container.querySelector(`input[name="properties[${name}]"]`);

    if (!input) {
      input = document.createElement("input");
      input.type = "hidden";
      input.name = `properties[${name}]`;
      container.appendChild(input);
    }

    input.value = value;
  }

  // Calculations
  calculateRatio() {
    const { maxWidth = 600 } = this.props;
    const { configuration, width, productHandle } = this.state;
    const widthsMapping = WIDTHS[productHandle];
    const widthValues = Object.keys(widthsMapping)
      .sort((a, b) => a - b)
      .map(Number);
    const max = Math.max(...widthValues);
    return maxWidth / max;
  }

  getSeats() {
    const { configuration, width, seatsState, productHandle } = this.state;
    const widthsMapping = WIDTHS[productHandle];
    const map = widthsMapping[width]?.seat;

    if (seatsState && seatsState in map) {
      return seatsState;
    }

    const svs = Object.keys(map)
      .map(Number)
      .sort((a, b) => a - b);
    return svs[svs.length - 1];
  }

  // Render methods
  renderSeats() {
    const { configuration, width, depth, direction, withChaise, productHandle } = this.state;
    
    const widthsMapping = WIDTHS[productHandle];
    const depthsMapping = DEPTHS[productHandle] ?? DEFAULT_DEPTH;

    console.log(`productHandle: ${productHandle}`)
    console.log(`widthsMapping: ${widthsMapping}`)
    console.log(`depthsMapping: ${depthsMapping}`)
    
    const seats = this.getSeats();
    const ratio = this.calculateRatio();


    const widthChaiseOffset = Math.min(...CHAISE_WIDTHS);
    const width1 = width - (withChaise ? widthChaiseOffset : 0);
    const width2 = width1 * ratio;
    const depth2 = depth * ratio;

    const armWidth = widthsMapping[width]?.arm;
    const armWidth2 = armWidth * ratio;

    const seatWidth0 = withChaise
      ? (width1 - armWidth * 2) / seats
      : (width1 - armWidth * 2) / seats;

    const seatWidth = seatWidth0 * ratio;
    const seatDepth0 = depthsMapping[depth].seat;
    const seatDepth = seatDepth0 * ratio;

    const frameWidth = (width2 - seatWidth * seats) / (withChaise ? 1 : 2);
    const frameDepth = frameWidth;

    const pillowDepth = depth2 - (armWidth2 + seatDepth);
    const seatWidth2 = withChaise
      ? seatWidth
      : ((width - armWidth * 2) / seats) * ratio;

    const dirop = direction === "right" ? "left" : "right";
    const seatContainerWidth = width2 - (withChaise ? 2 : 2) * armWidth2;

    // Create individual seat elements
    const els = range(seats).map((i) => {
      const prps = {
        position: "relative",
        border: `${BORDER_WIDTH}px solid #202020`,
      };

      const sw = seatWidth2;
      return React.createElement(
        "div",
        {
          key: `seat-${i}`,
        },
        [
          React.createElement("div", {
            key: `pillow-${i}`,
            className: "pillow",
            style: {
              ...prps,
              borderRadius: BORDER_RADIUS_PILLOW,
              width: sw,
              height: pillowDepth + BORDER_WIDTH * 2,
              top: -BORDER_WIDTH,
              backgroundColor: "#CCCCCC",
              borderColor: "#595959",
              zIndex: 2,
            },
          }),

          React.createElement(
            "div",
            {
              key: `seat-base-${i}`,
              className: "seat",
              style: {
                ...prps,
                borderRadius: BORDER_RADIUS_SEAT,
                backgroundColor: "#FFFDF8",
                width: sw,
                height: seatDepth,
                top: -BORDER_WIDTH * 2,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1,
                position: "relative",
              },
            },
            [
              i === 0 && React.createElement(
                "div",
                {
                  style: {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                    height: "100%",
                    position: "relative",
                  }
                },
                [
                  React.createElement(
                    "div",
                    {
                      style: {
                        display: "flex",
                        position: "relative",
                        alignItems: "center",
                        height: "100%",
                      }
                    },
                    [
                      React.createElement("div", {
                        style: {
                          marginRight: "10px"
                        }
                      }, [
                        React.createElement(Text, {
                          small: true,
                          style: {
                            lineHeight: "16px",
                            textAlign: "center",
                            marginBottom: "4px",
                          },
                        }, `${seatDepth0}\u201D`),

                        React.createElement(Text, {
                          small: true,
                          style: {
                            lineHeight: "16px",
                            textAlign: "center",
                          },
                        }, "Seat Depth"),
                      ]),

                      // Vertical line positioned to the right of the text
                      React.createElement("div", {
                        style: {
                          opacity: 0.5,
                          height: "calc(100% - 10px)",
                          width: 5 + 1.5 + 5,
                          position: "relative",
                          borderTop: '1.5px solid #A1A1A1',
                          borderBottom: '1.5px solid #A1A1A1',
                        },
                      }, [
                        React.createElement("div", {
                          style: {
                            width: 1.5,
                            height: "100%",
                            backgroundColor: "#A1A1A1",
                            position: "absolute",
                            top: 0,
                            bottom: 0,
                            left: 0,
                            right: 0,
                            margin: '0 auto',
                          }
                        }),
                      ]),
                    ]
                  ),
                ]
              )
            ]
          ),
        ]
      );
    });

    return React.createElement(
      "div",
      {
        style: {
          width: seatContainerWidth,
          position: "relative",
          display: "flex",
          top: BORDER_WIDTH * 2,
        },
      },
      els
    );
  }

  renderChaise() {
    const { withChaise, direction, depth, lengthChaise, widthChaise, productHandle } =
      this.state;

    if (!withChaise) return null;

    const ratio = this.calculateRatio();
    const depth2 = depth * ratio;
    const widthChaise2 = widthChaise * ratio;
    const lengthChaise2 = lengthChaise * ratio;

    const armWidth = WIDTHS[productHandle][this.state.width]?.arm;
    const armWidth2 = armWidth * ratio;

    const cw = armWidth2 + widthChaise2;
    const dirop = direction === "right" ? "left" : "right";

    // Create chaise text label
    const textc = React.createElement(
      Text,
      {
        small: true,
        style: {
          lineHeight: "16px",
          textAlign: dirop,
        },
      },
      lengthChaise,
      "\u201D",
      React.createElement("br"),
      "chaise",
      React.createElement("br"),
      "length"
    );

    // Calculate pillow depth
    const seatDepth0 = (DEPTHS[productHandle] ?? DEFAULT_DEPTH)[
      depth
    ].seat;
    const seatDepth = seatDepth0 * ratio;
    const pillowDepth = depth2 - (armWidth2 + seatDepth);

    return React.createElement(
      "div",
      {
        style: {
          position: "relative",
          display: "flex",
          ...(direction === "right" ? {} : { justifyContent: "flex-end" }),
          height: depth2 + FRAME_PADDING * 4,
          width: cw + FRAME_PADDING * 2,
          [dirop]: -(FRAME_PADDING * 2) + FRAME_GAP - armWidth2,
          zIndex: 3,
        },
      },
      [
        // Width label
        React.createElement(
          "div",
          {
            key: "width-label",
            style: {
              position: "absolute",
              top: 0,
              width: widthChaise2,
              height: FRAME_PADDING * 1.25,
              display: "flex",
              justifyContent: "center",
              borderBottom: `${BORDER_WIDTH / 2}px solid #A1A1A1`,
              [dirop]: 0,
            },
          },
          [
            React.createElement("div", {
              key: "left-marker",
              style: {
                height: 20,
                width: BORDER_WIDTH / 2,
                backgroundColor: "#A1A1A1",
                zIndex: 1,
                position: "absolute",
                left: 0,
                bottom: 0,
                transform: `translateY(calc(100% - ${(20 - BORDER_WIDTH / 2) / 2
                  }px))`,
              },
            }),

            React.createElement("div", {
              key: "right-marker",
              style: {
                height: 20,
                width: BORDER_WIDTH / 2,
                backgroundColor: "#A1A1A1",
                zIndex: 1,
                position: "absolute",
                right: 0,
                bottom: 0,
                transform: `translateY(calc(100% - ${(20 - BORDER_WIDTH / 2) / 2
                  }px))`,
              },
            }),

            React.createElement(
              Text,
              {
                key: "width-text",
                small: true,
                style: {
                  lineHeight: "16px",
                  textAlign: "center",
                },
              },
              widthChaise,
              "\u201D",
              React.createElement("br"),
              "width"
            ),
          ]
        ),

        // Length label
        React.createElement(
          "div",
          {
            key: "length-label",
            style: {
              position: "absolute",
              [direction]: 0,
              top: FRAME_PADDING * 2,
              height: lengthChaise2,
              display: "flex",
              ...(direction === "right" ? { justifyContent: "flex-end" } : {}),
              alignItems: "center",
              [`border${direction === "right" ? "Left" : "Right"}`]: `${BORDER_WIDTH / 2
                }px solid #A1A1A1`,
              width: FRAME_PADDING * 1.25,
            },
          },
          [
            React.createElement("div", {
              key: "top-marker",
              style: {
                width: 20,
                height: BORDER_WIDTH / 2,
                backgroundColor: "#A1A1A1",
                zIndex: 1,
                position: "absolute",
                [dirop]: 0,
                top: 0,
                transform: `translateX(calc(${direction === "right" ? -100 : 100
                  }% + ${((20 - BORDER_WIDTH / 2) / 2) *
                  (direction === "right" ? 1 : -1)
                  }px))`,
              },
            }),

            React.createElement("div", {
              key: "bottom-marker",
              style: {
                width: 20,
                height: BORDER_WIDTH / 2,
                backgroundColor: "#A1A1A1",
                zIndex: 1,
                position: "absolute",
                [dirop]: 0,
                bottom: 0,
                transform: `translateX(calc(${direction === "right" ? -100 : 100
                  }% + ${((20 - BORDER_WIDTH / 2) / 2) *
                  (direction === "right" ? 1 : -1)
                  }px))`,
              },
            }),

            textc,
          ]
        ),

        // Chaise body
        React.createElement(
          "div",
          {
            key: "chaise-body",
            style: {
              alignItems: "flex-end",
              backgroundColor: "#FFFBF0",
              border: `${BORDER_WIDTH}px solid #202020`,
              borderLeft: `${BORDER_WIDTH}px solid #202020`,
              borderRadius: BORDER_RADIUS_PILLOW,
              borderRight: `${BORDER_WIDTH}px solid #202020`,
              display: "flex",
              height: lengthChaise2,
              justifyContent: "center",
              position: "relative",
              top: FRAME_PADDING * 2,
              width: cw,
            },
          },
          [
            // Back
            React.createElement("div", {
              key: "back",
              className: "back",
              style: {
                borderRadius: BORDER_RADIUS_FRAME,
                backgroundColor: "#D3D3D3",
                border: `${BORDER_WIDTH}px solid #A1A1A1`,
                height: armWidth2,
                width: cw - armWidth2,
                [dirop]: -BORDER_WIDTH,
                top: -BORDER_WIDTH,
                position: "absolute",
              },
            }),

            // Arm
            React.createElement("div", {
              key: "arm",
              className: "arm",
              style: {
                borderRadius: BORDER_RADIUS_FRAME,
                backgroundColor: "#D3D3D3",
                border: `${BORDER_WIDTH}px solid #A1A1A1`,
                height: depth2 + BORDER_WIDTH,
                width: armWidth2,
                [direction]: -BORDER_WIDTH,
                top: -BORDER_WIDTH,
                position: "absolute",
              },
            }),

            // Pillow
            React.createElement("div", {
              key: "pillow",
              className: "pillow",
              style: {
                borderRadius: BORDER_RADIUS_PILLOW,
                backgroundColor: "#CCCCCC",
                border: `${BORDER_WIDTH}px solid #595959`,
                width: cw - armWidth2,
                height: pillowDepth + BORDER_WIDTH * 2,
                top: armWidth2 - BORDER_WIDTH * 2,
                [dirop]: -BORDER_WIDTH,
                zIndex: 2,
                position: "absolute",
              },
            }),

            React.createElement("div", { style: {} }),
          ]
        ),
      ]
    );
  }

  renderFrame() {
    const { configuration, width, depth, direction, withChaise, widthChaise, productHandle } =
      this.state;
    
    const widthsMapping = WIDTHS[productHandle];
    const depthsMapping = DEPTHS[productHandle] ?? DEFAULT_DEPTH;
    
    console.log(`productHandle: ${productHandle}`)
    console.log(`widthsMapping:`, widthsMapping)
    console.log(`depthsMapping:`, depthsMapping)
    
    const ratio = this.calculateRatio();
    const seats = this.getSeats();

    const widthChaiseOffset = Math.min(...CHAISE_WIDTHS);
    const width1 = width - (withChaise ? widthChaiseOffset : 0);
    const width2 = width1 * ratio;
    const depth2 = depth * ratio;

    const armWidth = widthsMapping[width]?.arm;
    const armWidth2 = armWidth * ratio;

    const seatWidth0 = withChaise
      ? (width1 - armWidth * 2) / seats
      : (width1 - armWidth * 2) / seats;
    const seatWidth = seatWidth0 * ratio;

    const seatDepth0 = depthsMapping[depth].seat;
    const seatDepth = seatDepth0 * ratio;

    const frameWidth = (width2 - seatWidth * seats) / (withChaise ? 1 : 2);
    const dirop = direction === "right" ? "left" : "right";

    // Create an array of elements with proper keys
    const frameElements = [];

    // Width label at top
    // frameElements.push(
    //   React.createElement(
    //     "div",
    //     {
    //       key: "width-label",
    //       style: {
    //         position: "absolute",
    //         top: 0,
    //         width: width2 - (withChaise ? 1 : 0) * armWidth2,
    //         height: FRAME_PADDING * 1.25,
    //         display: "flex",
    //         justifyContent: "center",
    //         borderBottom: `${BORDER_WIDTH / 2}px solid #A1A1A1`,
    //         ...(withChaise
    //           ? {
    //             ...(direction === "right"
    //               ? {
    //                 transform: `translateX(calc(${-armWidth2 / 2}px))`,
    //               }
    //               : {
    //                 transform: `translateX(calc(${armWidth2 / 2}px))`,
    //               }),
    //           }
    //           : {}),
    //       },
    //     },
    //     [
    //       React.createElement("div", {
    //         key: "left-marker",
    //         style: {
    //           height: 20,
    //           width: BORDER_WIDTH / 2,
    //           backgroundColor: "#A1A1A1",
    //           zIndex: 1,
    //           position: "absolute",
    //           left: 0,
    //           bottom: 0,
    //           transform: `translateY(calc(100% - ${(20 - BORDER_WIDTH / 2) / 2
    //             }px))`,
    //         },
    //       }),
    //       React.createElement("div", {
    //         key: "right-marker",
    //         style: {
    //           height: 20,
    //           width: BORDER_WIDTH / 2,
    //           backgroundColor: "#A1A1A1",
    //           zIndex: 1,
    //           position: "absolute",
    //           right: 0,
    //           bottom: 0,
    //           transform: `translateY(calc(100% - ${(20 - BORDER_WIDTH / 2) / 2
    //             }px))`,
    //         },
    //       }),
    //       React.createElement(
    //         Text,
    //         {
    //           key: "width-text",
    //           small: true,
    //           style: {
    //             lineHeight: "16px",
    //             textAlign: "center",
    //           },
    //         },
    //         width - (withChaise ? widthChaise : 0),
    //         "\u201D",
    //         React.createElement("br"),
    //         "width"
    //       ),
    //     ]
    //   )
    // );

    // Depth label on side (only shown when not withChaise)
    // if (!withChaise) {
    //   frameElements.push(
    //     React.createElement(
    //       "div",
    //       {
    //         key: "depth-label",
    //         style: {
    //           position: "absolute",
    //           [dirop]: 0,
    //           top: FRAME_PADDING * 2,
    //           height: depth2,
    //           display: "flex",
    //           justifyContent: "flex-start",
    //           alignItems: "center",
    //           borderRight: `${BORDER_WIDTH / 2}px solid #A1A1A1`,
    //           width: FRAME_PADDING * 1.25,
    //         },
    //       },
    //       [
    //         React.createElement("div", {
    //           key: "top-marker",
    //           style: {
    //             width: 20,
    //             height: BORDER_WIDTH / 2,
    //             backgroundColor: "#A1A1A1",
    //             zIndex: 1,
    //             position: "absolute",
    //             right: 0,
    //             top: 0,
    //             transform: `translateX(calc(100% - ${(20 - BORDER_WIDTH / 2) / 2
    //               }px))`,
    //           },
    //         }),
    //         React.createElement("div", {
    //           key: "bottom-marker",
    //           style: {
    //             width: 20,
    //             height: BORDER_WIDTH / 2,
    //             backgroundColor: "#A1A1A1",
    //             zIndex: 1,
    //             position: "absolute",
    //             right: 0,
    //             bottom: 0,
    //             transform: `translateX(calc(100% - ${(20 - BORDER_WIDTH / 2) / 2
    //               }px))`,
    //           },
    //         }),
    //         React.createElement(
    //           Text,
    //           {
    //             key: "depth-text",
    //             small: true,
    //             style: {
    //               lineHeight: "16px",
    //               textAlign: "right",
    //             },
    //           },
    //           depth,
    //           "\u201D",
    //           React.createElement("br"),
    //           "depth"
    //         ),
    //       ]
    //     )
    //   );
    // }

    // // Seat width label at bottom
    // frameElements.push(
    //   React.createElement(
    //     "div",
    //     {
    //       key: "seat-width-label",
    //       style: {
    //         position: "absolute",
    //         bottom: 0,
    //         margin: "0 auto",
    //         width: seatWidth - BORDER_WIDTH,
    //         height: FRAME_PADDING * 1.25,
    //         display: "flex",
    //         justifyContent: "center",
    //         alignItems: "flex-end",
    //         borderTop: `${BORDER_WIDTH / 2}px solid #A1A1A1`,
    //         ...(withChaise && direction === "left"
    //           ? {
    //             right: FRAME_PADDING * 2 + armWidth2 + BORDER_WIDTH / 2,
    //           }
    //           : {
    //             left: FRAME_PADDING * 2 + armWidth2 + BORDER_WIDTH / 2,
    //           }),
    //       },
    //     },
    //     [
    //       React.createElement("div", {
    //         key: "left-marker",
    //         style: {
    //           height: 20,
    //           width: BORDER_WIDTH / 2,
    //           backgroundColor: "#A1A1A1",
    //           zIndex: 1,
    //           position: "absolute",
    //           left: 0,
    //           top: 0,
    //           transform: `translateY(calc(-100% + ${(20 - BORDER_WIDTH / 2) / 2
    //             }px))`,
    //         },
    //       }),
    //       React.createElement("div", {
    //         key: "right-marker",
    //         style: {
    //           width: BORDER_WIDTH / 2,
    //           height: 20,
    //           backgroundColor: "#A1A1A1",
    //           zIndex: 1,
    //           position: "absolute",
    //           right: 0,
    //           top: 0,
    //           transform: `translateY(calc(-100% + ${(20 - BORDER_WIDTH / 2) / 2
    //             }px))`,
    //         },
    //       }),
    //       React.createElement(
    //         Text,
    //         {
    //           key: "seat-width-text",
    //           small: true,
    //           style: {
    //             lineHeight: "16px",
    //             textAlign: "center",
    //           },
    //         },
    //         Math.round(seatWidth0 * 100) / 100,
    //         "\u201D",
    //         React.createElement("br"),
    //         "seat width"
    //       ),
    //     ]
    //   )
    // );

    // Main frame
    frameElements.push(
      React.createElement(
        "div",
        {
          key: "main-frame",
          className: "frame",
          style: {
            backgroundColor: "#FFFBF0",
            display: "flex",
            alignItems: "flex-end",
            justifyContent: "center",
            height: depth2,
            width: width2,
            position: "relative",
            // top: FRAME_PADDING * 2,
            top: 0,
          },
        },
        [
          // Back
          React.createElement("div", {
            key: "back",
            className: "back",
            style: {
              height: armWidth2,
              width: width2 + BORDER_WIDTH * 0 - armWidth2 * 2,
              ...(withChaise
                ? {
                  ...(direction === "right"
                    ? {
                      left: armWidth2,
                    }
                    : {
                      right: armWidth2,
                    }),
                }
                : {}),
              top: 0,
              backgroundColor: "#D3D3D3",
              position: "absolute",
              border: `${BORDER_WIDTH}px solid #A1A1A1`,
              borderRadius: BORDER_RADIUS_FRAME,
            },
          }),

          // Left arm
          (!withChaise || direction === "right") &&
          React.createElement("div", {
            key: "arm-left",
            className: "arm-left",
            style: {
              height: depth2,
              width: armWidth2,
              left: 0,
              top: 0,
              backgroundColor: "#D3D3D3",
              position: "absolute",
              border: `${BORDER_WIDTH}px solid #A1A1A1`,
              borderRadius: BORDER_RADIUS_FRAME,
            },
          }),

          // Right arm
          (!withChaise || direction === "left") &&
          React.createElement("div", {
            key: "arm-right",
            className: "arm-right",
            style: {
              height: depth2,
              width: armWidth2,
              top: 0,
              backgroundColor: "#D3D3D3",
              right: 0,
              position: "absolute",
              border: `${BORDER_WIDTH}px solid #A1A1A1`,
              borderRadius: BORDER_RADIUS_FRAME,
            },
          }),

          // Seats
          this.renderSeats(),
        ]
      )
    );

    return React.createElement(
      "div",
      {
        style: {
          position: "relative",
          display: "flex",
          justifyContent: "center",
          height: depth2 + (FRAME_PADDING * 0),
          width: width2 + (FRAME_PADDING * 0),
        },
      },
      frameElements
    );
  }

  getCalculatedDimensions() {
    const { maxWidth = 600 } = this.props;
    const {
      configuration,
      direction,
      depth,
      width,
      withChaise,
      widthChaise,
      lengthChaise,
      seatsState,
      productHandle,
    } = this.state;

    // Mapping and values
    const widthsMapping = WIDTHS[productHandle];
    const depthsMapping = DEPTHS[productHandle] ?? DEFAULT_DEPTH;

    const widthValues = Object.keys(widthsMapping)
      .sort((a, b) => a - b)
      .map(Number);
    const max = Math.max(...widthValues);
    const min = Math.min(...widthValues);
    const ratio = maxWidth / max;

    // Calculate seats based on available options and state
    const seats = (() => {
      const map = widthsMapping[width]?.seat;
      if (!map) return 1;

      if (seatsState && seatsState in map) {
        return seatsState;
      }

      const svs = Object.keys(map)
        .map(Number)
        .sort((a, b) => a - b);
      return svs[svs.length - 1] || 1;
    })();

    // Chaise dimensions and calculations
    const widthChaiseOffset = Math.min(...CHAISE_WIDTHS);
    const width1 = width - (withChaise ? widthChaiseOffset : 0);
    const width2 = width1 * ratio;

    const depth2 = depth * ratio;

    const widthChaise2 = widthChaise * ratio;
    const lengthChaise2 = lengthChaise * ratio;

    // Calculate maximum possible depth for stable container height
    // This now properly considers if a chaise is present
    const maxPossibleDepth =
      Math.max(
        ...Object.keys(DEFAULT_DEPTH).map(Number),
        ...(withChaise ? CHAISE_LENGTHS_DEFAULT : [])
      ) * ratio;

    // Use a fixed container height based on the maximum possible dimensions
    const containerHeight = maxPossibleDepth + (FRAME_PADDING * 0);

    // Max depth calculations - also properly considers chaise
    const maxDepth =
      Math.max(
        ...Object.keys(depthsMapping).map(Number),
        ...(withChaise ? [Math.max(...CHAISE_LENGTHS_DEFAULT)] : [])
      ) * ratio;

    // Arm and seat calculations
    const armWidth = widthsMapping[width]?.arm || 0;

    // Ensure we have valid values to prevent division by zero
    const seatWidth0 = withChaise
      ? (width1 - armWidth * 2) / seats
      : (width1 - armWidth * 2) / seats;

    const seatWidth = seatWidth0 * ratio;

    // Make sure we have a valid depth before accessing properties
    const seatDepth0 = depthsMapping[depth]?.seat || 0;
    const seatDepth = seatDepth0 * ratio;

    // Frame calculations
    const frameWidth =
      (width2 - seatWidth * seats) / (widthChaise && withChaise ? 1 : 2);
    const frameDepth = frameWidth;

    const armWidth2 = armWidth * ratio;
    const pillowDepth = depth2 - (armWidth2 + seatDepth);

    const seatWidth2 = withChaise
      ? seatWidth
      : ((width - armWidth * 2) / seats) * ratio;

    return {
      ratio,
      width1,
      width2,
      depth2,
      widthChaise2,
      lengthChaise2,
      maxDepth,
      maxPossibleDepth,
      containerHeight,
      seats,
      seatWidth,
      seatWidth0,
      seatDepth,
      seatDepth0,
      frameWidth,
      frameDepth,
      armWidth,
      armWidth2,
      pillowDepth,
      seatWidth2,
      widthValues,
      widthsMapping,
      depthsMapping,
    };
  }

  // Add to componentDidMount in SofaSlider
  componentDidMount() {
    // Update dimensions display on initial load
    this.updateDimensionsDisplay();
  }

  updateDimensionsDisplay() {
    const {
      configuration,
      width,
      depth,
      widthChaise,
      lengthChaise,
    } = this.state;

    const dimensionsElement = document.getElementById("sofa-size-slider-dimensions");
    if (dimensionsElement) {
      let dimensionsText = `${width}″ Width × ${depth}″ Depth`;

      if (configuration === "chaise") {
        dimensionsText += ` · Chaise: ${widthChaise}″ × ${lengthChaise}″`;
      }

      dimensionsElement.textContent = dimensionsText;
    }
  }

  render() {
    const { maxWidth = 600 } = this.props;
    const {
      configuration,
      direction,
      depth,
      width,
      withChaise,
      widthChaise,
      productHandle,
      lengthChaise,
    } = this.state;
    const seats = this.getSeats();

    console.log("props", this.props);
    console.log("state", this.state);
    console.log("dimensions", this.getCalculatedDimensions());

    // Get calculated dimensions from the helper method
    const {
      ratio,
      width1,
      width2,
      depth2,
      widthChaise2,
      lengthChaise2,
      maxDepth,
      maxPossibleDepth,
      containerHeight,
      seatWidth,
      seatDepth,
      frameWidth,
      frameDepth,
      armWidth,
      armWidth2,
      pillowDepth,
      seatWidth2,
    } = this.getCalculatedDimensions();

    return React.createElement(
      "div",
      {
        style: {
          // padding: "10px 0px",
          display: "flex",
          flexDirection: "column",
          gap: 0,
        },
      },

      [

        // Top visualization area with FIXED height
        React.createElement(
          "div",
          {
            key: "visualization",
            style: {
              display: "flex",
              justifyContent: "center",
              height: containerHeight,
            },
          },
          [
            direction === "left" && this.renderChaise(),
            this.renderFrame(),
            direction === "right" && this.renderChaise(),
          ]
        ),

        // Width and depth sliders
        React.createElement(
          "div",
          {
            key: "dimension-sliders",
            style: {
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              gap: 0,
              justifyContent: "center",
              marginBottom: 20,
            },
          },
          [
            React.createElement(TickedSlider, {
              maxWidth: maxWidth,
              key: "width-slider",
              label: "Width",
              onChange: this.setWidth,
              widths: WIDTHS[productHandle],
              value: width,
              popularValues: [
                {
                  value: POPULAR[productHandle].width,
                  label: `${POPULAR[productHandle].width}″ popular`
                },
                // Add more if needed
              ]
            }),

            React.createElement(TickedSlider, {
              maxWidth: maxWidth,
              key: "depth-slider",
              label: "Depth",
              onChange: this.setDepth,
              widths: DEPTHS[productHandle] ?? DEFAULT_DEPTH,
              value: depth,
              popularValues: [
                {
                  value: POPULAR[productHandle].depth,
                  label: `${POPULAR[productHandle].depth}″ popular`
                },
                // Add more if needed
              ]
            }),
          ]
        ),

        // Seat selection
        React.createElement(
          "div",
          {
            key: "seat-selection",
            style: {
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            },
          },

          React.createElement(
            "div",
            {
              style: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 10,
                width: maxWidth,
              },
            },
            range(3).map((i) => {
              const seatNumber = i + 1;
              const disabled = !(
                String(seatNumber) in WIDTHS[productHandle][width].seat
              );

              return React.createElement(
                "button",
                {
                  key: `seat-button-${i}`,
                  onClick: (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    if (disabled) return;
                    this.setSeatsState(seatNumber);
                  },
                  style: {
                    padding: 10,
                    appearance: "none",
                    border: "3px solid",
                    ...(disabled
                      ? {
                        opacity: 0.3,
                        cursor: "not-allowed",
                      }
                      : {
                        cursor: "pointer",
                      }),
                    borderRadius: 10,
                    backgroundColor: "transparent",
                    display: "flex",
                    flex: 1,
                    justifyContent: "center",
                    flexDirection: "column",
                    alignItems: "center",
                    borderColor: seatNumber === seats ? "#124a6a" : "#34404C4D",
                  },
                },
                [
                  React.createElement(
                    Text,
                    {
                      key: "cushion",
                      style: {
                        lineHeight: "18px",
                        fontWeight: 500,
                      },
                      small: true,
                    },
                    `${seatNumber} ${pluralize('Cushion', seatNumber, true, true)} &`
                  ),

                  React.createElement(
                    Text,
                    {
                      key: "pillow",
                      style: {
                        lineHeight: "18px",
                        fontWeight: 500,
                      },
                      small: true,
                    },
                    `${pluralize('Back pillow', seatNumber, true, true)}`,
                  ),
                ]
              );
            })
          )
        ),

        // Chaise controls
        withChaise &&
        React.createElement(
          React.Fragment,
          {
            key: "chaise-controls",
          },
          [
            // Chaise dimension sliders
            React.createElement(
              "div",
              {
                key: "chaise-sliders",
                style: {
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "column",
                  gap: 0,
                  justifyContent: "center",
                },
              },
              [
                React.createElement(TickedSlider, {
                  maxWidth: maxWidth,
                  key: "chaise-length",
                  label: "Chaise Length",
                  onChange: this.setLengthChaise,
                  widths: CHAISE_LENGTHS_DEFAULT.reduce(
                    (acc, v) => ({ ...acc, [v]: v }),
                    {}
                  ),
                  value: lengthChaise,
                }),

                React.createElement(TickedSlider, {
                  maxWidth: maxWidth,
                  key: "chaise-width",
                  label: "Chaise Width",
                  onChange: this.setWidthChaise,
                  widths: CHAISE_WIDTHS.reduce(
                    (acc, v) => ({ ...acc, [v]: v }),
                    {}
                  ),
                  value: widthChaise,
                }),
              ]
            ),

            // Direction buttons
            React.createElement(
              "div",
              {
                key: "direction-buttons",
                style: {
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                },
              },
              React.createElement(
                "div",
                {
                  style: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 10,
                    width: maxWidth,
                  },
                },
                ["Left", "Right"].map((dir) =>
                  React.createElement(
                    "button",
                    {
                      key: `direction-${dir}`,
                      onClick: (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        this.setDirection(dir.toLowerCase());
                      },
                      style: {
                        padding: 10,
                        appearance: "none",
                        border: "3px solid",
                        cursor: "pointer",
                        borderRadius: 10,
                        backgroundColor: "transparent",
                        display: "flex",
                        flex: 1,
                        justifyContent: "center",
                        flexDirection: "column",
                        alignItems: "center",
                        borderColor:
                          direction === dir.toLowerCase()
                            ? "#124a6a"
                            : "#34404C4D",
                      },
                    },
                    React.createElement(
                      Text,
                      {
                        style: {
                          fontSize: 20,
                          fontWeight: 700,
                        },
                      },
                      withChaise ? "Chaise on " : "",
                      dir
                    )
                  )
                )
              )
            ),
          ]
        ),
      ],
    );
  }
}

/*
{
    "configuration": "sofa",
    "maxWidth": 600,
    "builderConfiguration": "sofa 2-seat",
    "builderStyle": "daphne",
    "cornerSettings": "Sofa",
    "fabricCollection": "fabric-samples",
    "firmnessProduct": "firmness",
    "fabricColor": [
        "Grey",
        "Colors",
        "Gunmetal",
        "Blue",
        "Ivory",
        "Brown",
        "Tan"
    ],
    "fabricTypes": [
        "Performance",
        "Woven",
        "Chenille",
        "Pet Friendly",
        "Best Seller",
        "Velvet"
    ],
    "fabricPatterns": [
        "amici",
        "apollo",
        "ashfield",
        "ashford",
        "bahama",
        "baylor",
        "bella",
        "bennett",
        "bermuda",
        "best",
        "best-seller",
        "bonterra",
        "bradley",
        "clarkson",
        "contessa",
        "dalton",
        "devon",
        "donnelly",
        "drayton",
        "dynamite",
        "elite",
        "empire-iii",
        "eton",
        "fern",
        "gypsy",
        "hampstead",
        "helio",
        "jallen",
        "james",
        "kimbell",
        "langley",
        "linen",
        "marlow",
        "marquise",
        "most-popular",
        "muse",
        "penelope",
        "performance"
    ],
    "fabricPopularCollections": "[\"bella|devon|bennette\"]",
    "sizeImage": "",
    "sizeModalContent": "",
    "sizeDescription": "",
    "sizeModalPage": "",
    "legOptions": [
        "custom-leg-models:45774310539491"
    ],
    "legOptionsPopup": "",
    "legModalPage": "",
    "sizeOptions": null,
    "productId": "8089677332707",
    "productHandle": "daphne-sofa",
    "productMetafieldsSize": {
        "corner_images": [
            {
                "filename": "Sofa.jpg",
                "mime_type": "image/jpeg",
                "media_type": "image",
                "alt": "",
                "id": 1686172577280,
                "key": "8089677332707/1686172577280/Sofa.jpg",
                "scope": "8089677332707",
                "handle": "1686172577280",
                "src": "https://cdn.accentuate.io/8089677332707/1686172577280/Sofa.jpg?v=1703371624589",
                "original_src": "https://original.accentuate.io/8089677332707/1686172577280/Sofa.jpg?v=1703371624589",
                "cloudinary_src": "https://cld.accentuate.io/8089677332707/1686172577280/Sofa.jpg?v=1703371624589&options=",
                "width": 600,
                "height": 396,
                "aspect_ratio": 1.515151515151515
            }
        ],
        "corner_settings": "Sofa",
        "cushion_description_sizes": [
            "",
            "",
            "",
            "",
            ""
        ],
        "cushion_image": [
            [
                {
                    "filename": "Sofa 2 Seat Standard Cushion.jpg",
                    "mime_type": "image/jpeg",
                    "media_type": "image",
                    "alt": "",
                    "id": 1689617883575,
                    "key": "8089677332707/1689617883575/Sofa-2-Seat-Standard-Cushion.jpg",
                    "scope": "8089677332707",
                    "handle": "1689617883575",
                    "src": "https://cdn.accentuate.io/8089677332707/1689617883575/Sofa-2-Seat-Standard-Cushion.jpg?v=1703725831497",
                    "original_src": "https://original.accentuate.io/8089677332707/1689617883575/Sofa-2-Seat-Standard-Cushion.jpg?v=1703725831497",
                    "cloudinary_src": "https://cld.accentuate.io/8089677332707/1689617883575/Sofa-2-Seat-Standard-Cushion.jpg?v=1703725831497&options=",
                    "width": 512,
                    "height": 512,
                    "aspect_ratio": 1
                }
            ]
        ],
        "cushion_image_sizes": [
            [
                {
                    "filename": "Sofa-2-Seat-Standard-Cushion (1).jpg",
                    "mime_type": "image/jpeg",
                    "media_type": "image",
                    "alt": "",
                    "id": 1732660587938,
                    "key": "8089677332707/1732660587938/Sofa-2-Seat-Standard-Cushion-(1).jpg",
                    "scope": "8089677332707",
                    "handle": "1732660587938",
                    "src": "https://cdn.accentuate.io/8089677332707/1732660587938/Sofa-2-Seat-Standard-Cushion-(1).jpg?v=1732660587938",
                    "original_src": "https://original.accentuate.io/8089677332707/1732660587938/Sofa-2-Seat-Standard-Cushion-(1).jpg?v=1732660587938",
                    "cloudinary_src": "https://cld.accentuate.io/8089677332707/1732660587938/Sofa-2-Seat-Standard-Cushion-(1).jpg?v=1732660587938&options=",
                    "width": 512,
                    "height": 512,
                    "aspect_ratio": 1
                }
            ],
            [
                {
                    "filename": "Sofa-2-Seat-Bench-Cushion.jpg",
                    "mime_type": "image/jpeg",
                    "media_type": "image",
                    "alt": "",
                    "id": 1718967519206,
                    "key": "8089677332707/1718967519206/Sofa-2-Seat-Bench-Cushion.jpg",
                    "scope": "8089677332707",
                    "handle": "1718967519206",
                    "src": "https://cdn.accentuate.io/8089677332707/1718967519206/Sofa-2-Seat-Bench-Cushion.jpg?v=1718967519206",
                    "original_src": "https://original.accentuate.io/8089677332707/1718967519206/Sofa-2-Seat-Bench-Cushion.jpg?v=1718967519206",
                    "cloudinary_src": "https://cld.accentuate.io/8089677332707/1718967519206/Sofa-2-Seat-Bench-Cushion.jpg?v=1718967519206&options=",
                    "width": 512,
                    "height": 512,
                    "aspect_ratio": 1
                }
            ],
            [
                {
                    "filename": "Sofa-2-Seat-Bench-Cushion (2)v2.jpg",
                    "mime_type": "image/jpeg",
                    "media_type": "image",
                    "alt": "",
                    "id": 1732660622676,
                    "key": "8089677332707/1732660622676/Sofa-2-Seat-Bench-Cushion-(2)v2.jpg",
                    "scope": "8089677332707",
                    "handle": "1732660622676",
                    "src": "https://cdn.accentuate.io/8089677332707/1732660622676/Sofa-2-Seat-Bench-Cushion-(2)v2.jpg?v=1732660622677",
                    "original_src": "https://original.accentuate.io/8089677332707/1732660622676/Sofa-2-Seat-Bench-Cushion-(2)v2.jpg?v=1732660622677",
                    "cloudinary_src": "https://cld.accentuate.io/8089677332707/1732660622676/Sofa-2-Seat-Bench-Cushion-(2)v2.jpg?v=1732660622677&options=",
                    "width": 512,
                    "height": 512,
                    "aspect_ratio": 1
                }
            ],
            [
                {
                    "filename": "Sofa-3-Seat-Standard-Cushion (2).jpg",
                    "mime_type": "image/jpeg",
                    "media_type": "image",
                    "alt": "",
                    "id": 1732660648740,
                    "key": "8089677332707/1732660648740/Sofa-3-Seat-Standard-Cushion-(2).jpg",
                    "scope": "8089677332707",
                    "handle": "1732660648740",
                    "src": "https://cdn.accentuate.io/8089677332707/1732660648740/Sofa-3-Seat-Standard-Cushion-(2).jpg?v=1732660648740",
                    "original_src": "https://original.accentuate.io/8089677332707/1732660648740/Sofa-3-Seat-Standard-Cushion-(2).jpg?v=1732660648740",
                    "cloudinary_src": "https://cld.accentuate.io/8089677332707/1732660648740/Sofa-3-Seat-Standard-Cushion-(2).jpg?v=1732660648740&options=",
                    "width": 512,
                    "height": 512,
                    "aspect_ratio": 1
                }
            ],
            [
                {
                    "filename": "cushion_sofa-3-back.webp",
                    "mime_type": "image/webp",
                    "media_type": "image",
                    "alt": "",
                    "id": 1732660692476,
                    "key": "8089677332707/1732660692476/cushion_sofa-3-back.webp",
                    "scope": "8089677332707",
                    "handle": "1732660692476",
                    "src": "https://cdn.accentuate.io/8089677332707/1732660692476/cushion_sofa-3-back.webp?v=1732660692476",
                    "original_src": "https://original.accentuate.io/8089677332707/1732660692476/cushion_sofa-3-back.webp?v=1732660692476",
                    "cloudinary_src": "https://cld.accentuate.io/8089677332707/1732660692476/cushion_sofa-3-back.webp?v=1732660692476&options=",
                    "width": 256,
                    "height": 256,
                    "aspect_ratio": 1
                }
            ]
        ],
        "cushion_title": [
            "Standard Cushions"
        ],
        "cushion_title_sizes": [
            "2 Cushion / 2 Back Pillow",
            "Bench Cushion / 2 Back Pillow",
            "Bench Cushion / 1 Back Pillow",
            "3 Cushion / 3 Back Pillow",
            "Bench Cushion / 3 Back Pillow"
        ],
        "min_width": [
            "",
            ""
        ],
        "size_option": [
            "option-set-200235-select-4",
            "sofa-depth-f"
        ]
    },
    "productMetafieldsBuilderInfo": {
        "configuration": "Sofa 2-Seat",
        "style": "Daphne"
    },
    "blockSettings": {
        "need-help-url": "https://whataroom.com/pages/design-consultation",
        "fabric_collection": "fabric-samples",
        "fabric_cta_text": "Order Free Fabric Samples",
        "fabric_cta_link": "/collections/fabric-samples",
        "firmness_product": "firmness",
        "firmness_popup": "firmness-popup",
        "cushion_popup": "seat-cushion-popup"
    }
}
*/
document.addEventListener("DOMContentLoaded", function() {
  const container = document.getElementById("sofa-size-slider-container");
  if (!(container && window.React && window.ReactDOM)) return;
  
  // Extract all dataset properties
  const {
    builderConfiguration,
    builderStyle,
    cornerSettings,
    fabricCollection,
    firmnessProduct,
    fabricColor,
    fabricTypes,
    fabricPatterns,
    fabricPopularCollections,
    sizeImage,
    sizeModalContent,
    sizeDescription,
    sizeModalPage,
    legOptions,
    legOptionsPopup,
    legModalPage,
    sizeOptions,
    productId,
    productHandle,
    productMetafieldsSize,
    productMetafieldsBuilderInfo,
    blockSettings,
  } = container.dataset;

  console.log(container.dataset);

  // Parse JSON data from dataset
  const parsedProps = {
    builderConfiguration,
    builderStyle,
    cornerSettings: tryParseJSON(cornerSettings),
    fabricCollection,
    firmnessProduct,
    fabricColor: tryParseJSON(fabricColor),
    fabricTypes: tryParseJSON(fabricTypes),
    fabricPatterns: tryParseJSON(fabricPatterns),
    fabricPopularCollections,
    sizeImage: tryParseJSON(sizeImage),
    sizeModalContent,
    sizeDescription,
    sizeModalPage,
    legOptions: tryParseJSON(legOptions),
    legOptionsPopup,
    legModalPage,
    sizeOptions: tryParseJSON(sizeOptions),
    productId,
    productHandle,
    productMetafieldsSize: tryParseJSON(productMetafieldsSize),
    productMetafieldsBuilderInfo: tryParseJSON(productMetafieldsBuilderInfo),
    blockSettings: tryParseJSON(blockSettings),
  };

  console.log("Parsed dataset props:", parsedProps);

  // Get configuration for the slider
  let configuration = builderConfiguration;
  if (!configuration?.length) {
    configuration = "sofa";
  }
  configuration = configuration.toLowerCase();
  if (!configuration) {
    configuration = "sofa";
  }

  if (configuration?.includes("chaise")) {
    configuration = "chaise";
  } else if (configuration?.includes("sofa")) {
    configuration = "sofa";
  }

  const getContainerWidth = () => {
    const wrapper = document.querySelector(".builder-wrapper.enavi-sofa-builder");
    return wrapper.offsetWidth;
  }

  const renderSlider = (containerWidth) => {
    try {
      // Use createRoot for React 18
      const root = ReactDOM.createRoot(container);
      root.render(
        React.createElement(SofaSlider, {
          configuration,
          maxWidth: containerWidth, // Use the container's width instead of a fixed value
          // Pass all the parsed props to the component
          ...parsedProps,
        })
      );

      console.log(
        "Sofa slider initialized successfully with width:",
        containerWidth
      );
    } catch (err) {
      console.error("Failed to initialize sofa slider:", err);
      container.innerHTML =
        "<p>Error: Could not load the sofa size configurator</p>";
    }
  };

  const containerWidthInit = getContainerWidth() - (20 * 2);

  window.addEventListener(
    "resize",
    debounce(() => {
      const newWidth = getContainerWidth() - (20 * 2);
      if (newWidth !== containerWidthInit) {
        renderSlider(newWidth);
        console.log("Sofa slider resized to:", newWidth);
      }
    }, 250)
  );

  renderSlider(containerWidthInit)
});

// Helper function to safely parse JSON
function tryParseJSON(jsonString) {
  if (!jsonString) return null;
  try {
    return JSON.parse(jsonString);
  } catch (e) {
    console.warn("Failed to parse JSON:", jsonString, e);
    return null;
  }
}

// Debounce function to limit how often a function runs during window resize
function debounce(func, wait) {
  let timeout;
  return function() {
    const context = this,
      args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      func.apply(context, args);
    }, wait);
  };
}
